
<router-outlet (activate)="onActivate($event)"></router-outlet>

<footer class="experiencefragment">
  <div class="footer-container">
    <div class="footer-main">
      <div class="footer-logo">
        <img src="assets/image/Coke-company-logo-white-large.svg" alt="Coca-Cola Logo">
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-copyright">
        <p>© 2025 The Coca-Cola Company. All rights reserved.</p>
      </div>
    </div>
  </div>
</footer>

<script>
  if (global === undefined) {
    var global = window;
  }
</script>
